<div class="grid-container">
    <mat-grid-list cols="2" rowHeight="80px">
        <mat-grid-tile [colspan]="1" [rowspan]="6">
            <mat-card class="activity-overview-card">
                <mat-card-header>
                    <mat-card-title>
                        {{ 'global.tasksList' | translate }}
                        <button *ngxPermissionsOnly="'tasks.uploader'"
                                mat-stroked-button
                                (click)="handleOnClick()"
                                color="primary"
                                class="upload-button"
                        >
                            <mat-icon class="upload-button-icon">cloud_upload</mat-icon>
                            {{ 'global.upload' | translate }}
                        </button>
                        <input
                                #fileInput
                                type="file"
                                (change)="handleOnChange($event)"
                                accept=".png,.jpeg,.pdf,.jpg"
                                style="display: none;"
                                multiple
                        />
                    </mat-card-title>

                    <mat-card-subtitle
                    >{{ invoiceStoreMetrics.invoiceReadingCount }}
                        {{ 'taskDetails.invoiceBeingRead' | translate }}
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-divider></mat-divider>
                <mat-card-content class="activity-overview-card-content">
                    <mat-list>
                        <!--apply the class depending on the number of task types : ex. 3 task types => task-list-items-3 goes from 1 to 5-->
                        <ng-container *ngFor="let task of tasks.data; let taskDefIndex = index">
                            <mat-list-item *ngxPermissionsOnly="'tasks.user'" class="mat-list-item-hover" [ngClass]="{
									'task-list-items-7': tasks.size === 7,
									'task-list-items-6': tasks.size === 6,
									'task-list-items-5': tasks.size === 5,
									'task-list-items-4': tasks.size === 4,
									'task-list-items-3': tasks.size === 3,
									'task-list-items-2': tasks.size === 2,
									'task-list-items-1': tasks.size === 1
								}"
                                           [attr.data-index]="taskDefIndex"
                                           (click)="navigateToTaskDetails(taskDefIndex)"
                            >
                                <h4 matLine>{{ task.name | uppercase }}</h4>
                                <p matLine>{{ task.documentation }}</p>
                                <div class="task-counter">
                                    {{ task.nbActiveTasks }}
                                </div>
                            </mat-list-item>
                            <mat-list-item *ngxPermissionsExcept="'tasks.user'"
                                           [ngClass]="{
									'task-list-items-7': tasks.size === 7,
									'task-list-items-6': tasks.size === 6,
									'task-list-items-5': tasks.size === 5,
									'task-list-items-4': tasks.size === 4,
									'task-list-items-3': tasks.size === 3,
									'task-list-items-2': tasks.size === 2,
									'task-list-items-1': tasks.size === 1
								}"
                                           [attr.data-index]="taskDefIndex"
                            >
                                <h4 matLine>{{ task.name | uppercase }}</h4>
                                <p matLine>{{ task.documentation }}</p>
                                <div class="task-counter">
                                    {{ task.nbActiveTasks }}
                                </div>
                            </mat-list-item>
                            <mat-divider *ngIf="taskDefIndex !== tasks.size - 1"></mat-divider>
                        </ng-container>
                    </mat-list>
                </mat-card-content>
            </mat-card>
        </mat-grid-tile>


        <mat-grid-tile [colspan]="1" [rowspan]="2">
            <mat-card class="activity-overview-card invoice-overview-card"
                      *ngxPermissionsOnly="['explorer.approved.editor', 'explorer.approved.viewer']"
                      (click)="navigateToInvoiceExplorer()">
                <div class="invoice-status-card">
                    <h3>
                        {{ 'activityOverview.invoicesSince' | translate }}
                    </h3>
                    <p class="desc-wrapper">
                        <span>{{ 'activityOverview.including' | translate }}</span>
                        <span class="unpaidApprovedInvoices">{{ totalUnpaidApprovedInvoiceCounter }}</span>
                        <span>{{ 'activityOverview.unpaidApprovedInvoices' | translate }}</span>
                    </p>
                    <div class="invoice-status-counter overview-green">
                        {{ totalPurchaseInvoiceCounter }}
                    </div>
                </div>
            </mat-card>
            <mat-card class="activity-overview-card"
                      *ngxPermissionsExcept="['explorer.approved.editor', 'explorer.approved.viewer']">
                <div class="invoice-status-card">
                    <h3>{{ 'activityOverview.invoicesSince' | translate }}</h3>
                    <p class="desc-wrapper">
                        <span>{{ 'activityOverview.including' | translate }}</span>
                        <span class="unpaidApprovedInvoices">{{ totalUnpaidApprovedInvoiceCounter }}</span>
                        <span>{{ 'activityOverview.unpaidApprovedInvoices' | translate }}</span>
                    </p>
                    <div class="invoice-status-counter overview-green">
                        {{ totalPurchaseInvoiceCounter }}
                    </div>
                </div>
            </mat-card>
        </mat-grid-tile>

        <mat-grid-tile [colspan]="1" [rowspan]="2">
            <mat-card class="activity-overview-card invoice-overview-card"
                      *ngxPermissionsOnly="['explorer.rejected.editor', 'explorer.rejected.viewer']"
                      (click)="navigateToInvoiceRejectedExplorer()">
                <div class="invoice-status-card">
                    <h3>{{'activityOverview.rejectedInvoice' | translate}}</h3>
                    <p>{{'activityOverview.rejectedDesc' | translate}}</p>
                    <div class="invoice-status-counter overview-red">
                        {{totalRejectedInvoiceCounter}}
                    </div>
                </div>
            </mat-card>
            <mat-card class="activity-overview-card"
                      *ngxPermissionsExcept="['explorer.rejected.editor', 'explorer.rejected.viewer']">
                <div class="invoice-status-card">
                    <h3>{{'activityOverview.rejectedInvoice' | translate}}</h3>
                    <p>{{'activityOverview.rejectedDesc' | translate}}</p>
                    <div class="invoice-status-counter overview-red">
                        {{totalRejectedInvoiceCounter}}
                    </div>
                </div>
            </mat-card>
        </mat-grid-tile>

        <mat-grid-tile [colspan]="1" [rowspan]="2">
            <mat-card class="activity-overview-card invoice-overview-card"
                      *ngxPermissionsOnly="['explorer.ongoing.editor', 'explorer.ongoing.viewer']"
                      (click)="navigateToInvoiceInProgressExplorer()">

                <div class="invoice-status-card">
                    <h3>{{ 'activityOverview.invoicesDuringProcessing' | translate }}</h3>
                    <p>{{'activityOverview.submittedinvoiceUnderControlAndValidation'| translate}}</p>
                    <div class="invoice-status-counter overview-grey">
                        {{ metrics.ongoingProcessesCount }}
                    </div>
                </div>
            </mat-card>
            <mat-card class="activity-overview-card"
                      *ngxPermissionsExcept="['explorer.ongoing.editor', 'explorer.ongoing.viewer']">

                <div class="invoice-status-card">
                    <h3>{{ 'activityOverview.invoicesDuringProcessing' | translate }}</h3>
                    <p>
                        {{
                        'activityOverview.submittedinvoiceUnderControlAndValidation'
                        | translate
                        }}
                    </p>
                    <div class="invoice-status-counter overview-grey">
                        {{ metrics.ongoingProcessesCount }}
                    </div>
                </div>
            </mat-card>
        </mat-grid-tile>
    </mat-grid-list>
</div>
